import { toast } from "react-toastify";

export const copyToClipboard = (content: string, message = "کپی شد.") => {
  if (navigator?.clipboard) {
    navigator.clipboard.writeText(content.toString());
    toast.success(message);
  } else {
    const textarea = document.createElement("textarea");
    textarea.textContent = content;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    toast.success(message);
  }
};

export function formatPersianDate(date: Date) {
  return {
    year: parseInt(
      new Intl.DateTimeFormat("en-US-u-ca-persian", {
        year: "numeric",
      })
        .format(date)
        .substring(0, 4) //remove AP chars
    ),
    month: parseInt(
      new Intl.DateTimeFormat("en-US-u-ca-persian", {
        month: "numeric",
      }).format(date)
    ),
    day: parseInt(
      new Intl.DateTimeFormat("en-US-u-ca-persian", {
        day: "numeric",
      }).format(date)
    ),
  };
}
